/**
 * Configuracoes de apontamento da API do Stampa Prodotti.
 */

const homologationsBaseUrls = [
    // PROD
    "https://homologacaonvi201.sgoas.nvi.com.br/api",

    // HML
    //"http://projetonvi202.sgoas.nvi.com.br/api",

    "http://localhost:5010/api",
    "https://localhost:5011/api",
];

const client = "stampa-prodotti-homologacao-postgre";

let baseURL;

if (window.location.href.includes("localhost")) {
    baseURL = "http://localhost:5010/api";
} else if (window.location.href.includes("UI")) {
    baseURL = window.location.href.substring(0, window.location.href.indexOf("UI")) + "api";
} else {
    baseURL = "/api";
}

const version = "0.1.0";

const appointments = {
    homologationsBaseUrls,
    baseURL,
    version,
    client,
};

export default appointments;
